import $ from 'jquery';

import Uploader from './uploader';

class AddAsset {
	
	constructor() {

		$("#assettype, #assetnamefield").change(function() {
			if ($("#assettype").val() != "" && $("#assetnamefield").val() != "") {
				$("#donext").prop("disabled", false);
			} else {
				$("#donext").prop("disabled", true);
			}
		}).keyup(function() {
			$(this).change();
		});

		$("#donext").click((e) => {
			e.preventDefault();
			if ($("#add-asset-step-2").is(":visible") && $("#uploader_assetfile").hasClass("uploaded")) {

				// do the save here..

				let name = $("#assetnamefield").val();
				let type = $("#assettype").val();
				let file = $("#uploader_assetfile").val();
				let section = $("#uploadModal").data("type");
				let id = $("#uploadModal").data("id");

				$.ajax({data:{op:"addAsset", name: name, type: type, file: file, section: section, id: id}});
				
				return;
			}

			$("#add-asset-step-2").show();
			$("#docancelasset").prop("disabled", false);
			$("#donext").prop("disabled", true);
		});


		$("#uploadModal").on("shown.bs.modal", () => {
			$("#uploader_assetfile").removeClass("uploading");
			$("#uploader_assetfile").removeClass("uploaded");
			$("#add-asset-step-2").hide();
			
			Uploader.setup($("#uploader_assetfile"));


			$("#uploader_assetfile").unbind('change').change(e => {
				console.log("Changed", $("#uploader_assetfile").hasClass("uploaded"));

				if ($("#uploader_assetfile").hasClass("uploading")) {
					$("#docancelasset").prop("disabled", true);
					$("#donext").prop("disabled", true);
				}

				// when this changes, it means that 
				if ($("#uploader_assetfile").hasClass("uploaded")) {
					$("#docancelasset").prop("disabled", false);
					$("#donext").prop("disabled", false);
				}

			});


			$("#assettype").change();
			$("#docancelasset").prop("disabled", false);

		});

	}

}

export default AddAsset;

